import React from "react"
import { Button } from "@mui/material"
import { handleDownload } from "src/sites/data-sources/DataSourcesTable"
import { useResponsive } from "src/utils/useResponsive"
import { SourceDoc } from "../km"

interface Props {
  doc: SourceDoc
}

export const SourceLinkButton = ({ doc }: Props) => {
  const { isMobile } = useResponsive()

  if (doc.metadata.doc_id) {
    return (
      <Button
        data-testid="km-external-source-button"
        size={isMobile ? "small" : "medium"}
        variant="contained"
        color="secondary"
        onClick={() => handleDownload(doc.metadata.doc_id, doc.metadata.source)}
        sx={{
          fontSize: { xs: "0.75rem", md: "0.875rem" },
          px: { xs: 1.5, md: 2 },
          py: { xs: 0.5, md: 1 }
        }}
      >
        Source link
      </Button>
    )
  }

  return (
    <Button
      data-testid="km-external-source-button"
      component="a"
      size={isMobile ? "small" : "medium"}
      variant="contained"
      color="secondary"
      href={doc.metadata.source}
      target="_blank"
      rel="noopener noreferrer"
      sx={{
        fontSize: { xs: "0.75rem", md: "0.875rem" },
        px: { xs: 1.5, md: 2 },
        py: { xs: 0.5, md: 1 }
      }}
    >
      Source link
    </Button>
  )
}
